export const comments_3253779 = {"data":{"data":[],"links":{}}}